module.exports = __webpack_public_path__ + "83a808bf51f3857e09186b041e470e38.svg";